import { useState } from 'react';
import axios, { API, errText } from '../api';
import { setSession } from '../auth';
import { colors } from '../theme';

const STEP = { MODE: 'mode', SUPER_PASSWORD: 'super_password', CURATOR_LOGIN: 'curator_login' };

// Собранный с REACT_APP_PANEL_MODE=admin/curator билд сразу открывает нужный шаг входа —
// так на admin.astrapeople.ru куратор не видит лишней кнопки "Я суперадмин" и наоборот
// (два раздельных билда на разных поддоменах, см. деплой-скрипт deploy-panels.sh).
const PANEL_MODE = process.env.REACT_APP_PANEL_MODE;
const INITIAL_STEP = PANEL_MODE === 'admin' ? STEP.SUPER_PASSWORD
  : PANEL_MODE === 'curator' ? STEP.CURATOR_LOGIN
  : STEP.MODE;

export default function Login() {
  const [step, setStep] = useState(INITIAL_STEP);
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [curatorPassword, setCuratorPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const run = async (fn) => {
    setError('');
    setLoading(true);
    try {
      await fn();
    } catch (e) {
      setError(errText(e, 'Что-то пошло не так'));
    }
    setLoading(false);
  };

  const superLogin = () => run(async () => {
    const r = await axios.post(`${API}/admin/login`, { password });
    setSession(r.data.access_token, 'super_admin');
    window.location.href = '/dashboard';
  });

  const curatorLogin = () => run(async () => {
    const r = await axios.post(`${API}/curator-auth/login`, { phone, password: curatorPassword });
    setSession(r.data.access_token, 'curator');
    window.location.href = '/dashboard';
  });

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <span style={styles.logoText}>ASTRA</span>
          <span style={styles.logoSub}>Панель управления</span>
        </div>

        {step === STEP.MODE && (
          <>
            <button style={styles.btn} onClick={() => setStep(STEP.SUPER_PASSWORD)}>Я суперадмин</button>
            <button style={styles.btnSecondary} onClick={() => setStep(STEP.CURATOR_LOGIN)}>Я куратор</button>
          </>
        )}

        {step === STEP.SUPER_PASSWORD && (
          <>
            <input style={styles.input} type="password" placeholder="Пароль суперадмина" value={password}
              onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && superLogin()} autoFocus />
            {error && <div style={styles.error}>{error}</div>}
            <button style={styles.btn} onClick={superLogin} disabled={loading}>{loading ? 'Вход…' : 'Войти'}</button>
            {!PANEL_MODE && <button style={styles.btnLink} onClick={() => setStep(STEP.MODE)}>← Назад</button>}
          </>
        )}

        {step === STEP.CURATOR_LOGIN && (
          <>
            <input style={styles.input} type="tel" placeholder="Телефон, +7..." value={phone}
              onChange={e => setPhone(e.target.value)} autoFocus />
            <input style={styles.input} type="password" placeholder="Пароль" value={curatorPassword}
              onChange={e => setCuratorPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && curatorLogin()} />
            {error && <div style={styles.error}>{error}</div>}
            <button style={styles.btn} onClick={curatorLogin} disabled={loading}>{loading ? 'Вход…' : 'Войти'}</button>
            {!PANEL_MODE && <button style={styles.btnLink} onClick={() => setStep(STEP.MODE)}>← Назад</button>}
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: colors.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '-apple-system, Segoe UI, sans-serif' },
  card: { background: colors.surface, borderRadius: 16, padding: 40, width: 360, display: 'flex', flexDirection: 'column', gap: 14 },
  logo: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 8 },
  logoText: { fontSize: 32, fontWeight: 700, color: colors.accent, letterSpacing: 2 },
  logoSub: { fontSize: 13, color: colors.textMuted, marginTop: 2 },
  input: { padding: '12px 16px', background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 8, fontSize: 14, color: colors.text, outline: 'none' },
  btn: { background: colors.accent, color: colors.bg, border: 'none', padding: '13px', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer' },
  btnSecondary: { background: 'transparent', color: colors.text, border: `1px solid ${colors.border}`, padding: '13px', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' },
  btnLink: { background: 'transparent', color: colors.textMuted, border: 'none', fontSize: 13, cursor: 'pointer', padding: 4 },
  error: { background: '#3a1c1c', border: '1px solid #7a3030', color: colors.danger, padding: '10px 14px', borderRadius: 8, fontSize: 13 },
};
